import { NgxLoggerLevel } from 'ngx-logger';

const companyConfig: any = {
  logo: './assets/beltrame/logo_AFV.png',
  expandedLogo: './assets/beltrame/logo_light.png',
  logoBg: 'bg0f273c',
  name: 'DIAS Beltrame',
  role: '*',
};

const grantedMailAddresses: string[] = [];

export const globalEnvironment = {
  name: 'DIAS Beltrame',
  production: false,
  company: companyConfig,
  routes: [],
  auth: {
    refreshing_time: 5000,
    token_lifespan: 60,
    bearerExcludedUrls: ['^https://diasbeltramestorage.blob.core.windows.net/', 'https://api.powerbi.com'],
    grantedMailAddresses,
  },
  logger: {
    serverLoggingUrl: 'http://localhost:3000/logs',
    level: NgxLoggerLevel.DEBUG,
    serverLogLevel: NgxLoggerLevel.ERROR,
  },
  powerbi: {
    groupId: '44ec9728-7b62-488f-9683-7af72f3885b9',
    reportId: 'c5998e2e-89a5-4fa3-955c-dcedf4847486',
  },
  render_delay: 400,
  refreshing_time: '10s',
  warn_timeout: 5000,
  error_timeout: 10000,
  snackbar_duration: 2000,
  snackbar_error_duration: 10000,
  date_format: 'MM-dd-yyyy HH:mm',
  first_available_date: '2021-01-01',
  supportUrl: 'https://support.cube.rina.org'
};
